import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [

  {
    path: '/',
    name: 'PracticeSelection',
    component: () => import(/* webpackChunkName: "practiceselection" */ '../views/PracticeSelection.vue'),
    meta: {
      restricted: false,
    },
    beforeEnter: (to, from, next) => {
      if(store.state.onSubdomain) {
        next({ name: 'Home' })
      }
      else {
        next()
      }
    },
  },
  {
    path: '/home/:anchor?',
    props: (route) => ({
      anchor: route.params.anchor,
    }),
    name: 'Home',
    component: Home,
    meta: {
      restricted: true,
    },
  },
  {
    path: '/faq',
    name: 'FAQ',
    component:  () => import(/* webpackChunkName: "faq" */ '../views/FAQ.vue'),
    meta: {
      restricted: true,
    },
  },
  {
    path: '/plans/:id',
    props: (route) => ({
      id: route.params.id,
    }),
    name: 'PlanDetail',
    component:  () => import(/* webpackChunkName: "plandetail" */ '../views/PlanDetail.vue'),
    meta: {
      restricted: true,
    },
  },
  {
    path: '/plans/:id/signup',
    props: (route) => ({
      id: route.params.id,
    }),
    name: 'Signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/Signup.vue'),
    meta: {
      restricted: true,
    },
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    component: () => import(/* webpackChunkName: "thankyou" */ '../views/Thankyou.vue'),
    meta: {
      restricted: true,
    },
  },
  {
    path: '/termsandconditions',
    name: 'TermsAndConditions',
    component: () => import(/* webpackChunkName: "TermsAndConditions" */ '../views/TermsAndConditions.vue'),
    meta: {
      restricted: false,
    },
  },
  {
    path: '/termsofuse',
    name: 'TermsOfUse',
    component: () => import(/* webpackChunkName: "TermsOfUse" */ '../views/TermsOfUse.vue'),
    meta: {
      restricted: false,
    },
  },
  {
    path: '/privacypolicy',
    name: 'PrivacyPolicy',
    component: () => import(/* webpackChunkName: "PrivacyPolicy" */ '../views/PrivacyPolicy.vue'),
    meta: {
      restricted: false,
    },
  },
]



const router = new VueRouter({
  routes
})
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

router.beforeEach(async (to, from, next) => {
  await store.dispatch('GET_PRACTICES')
  store.dispatch('SET_SUBDOMAIN')
  if(to.meta.restricted && !store.state.selectedPractice.id) {
    if(store.state.onSubdomain) {
      next()
    }
    else {
      alert('Please select your nearest practice.')
      if(router.currentRoute.name != 'PracticeSelection') {
        router.replace({ name: 'PracticeSelection' })
      }
    }
  }
  else {
    next()
  }
})

export default router
